import { Link } from "react-router-dom";
import { GoldenNewBadge } from "@/components/GoldenNewBadge";

export const Footer = () => (
  <footer className="pp-footer" data-testid="app-footer">
    <nav className="pp-footer-links no-print">
      <Link to="/about" data-testid="footer-about-link">About</Link>
      <Link to="/manners" data-testid="footer-manners-link">Everyday Manners</Link>
      <Link to="/dinner" data-testid="footer-dinner-link">Dinner Game</Link>
      <Link to="/sorry" data-testid="footer-sorry-link">The 3 Steps Of An Apology</Link>
      <Link to="/cards" data-testid="footer-cards-link">Card Library</Link>
      <Link to="/parents" data-testid="footer-tips-link">Parent Tips</Link>
      <Link to="/family#golden" data-testid="footer-family-link">Family Area <GoldenNewBadge /></Link>
      <Link to="/rewards" data-testid="footer-rewards-link">Rewards</Link>
      <Link to="/golden-acorns" data-testid="footer-golden-link">How Golden Acorns Work</Link>
      <Link to="/get-the-app" data-testid="footer-get-app-link">Get The App</Link>
      <Link to="/voice" data-testid="footer-voice-link">Siri & Alexa</Link>
    </nav>
    <nav className="pp-footer-links pp-footer-legal no-print">
      <Link to="/account" data-testid="footer-account-link">Account & Subscription</Link>
      <Link to="/terms" data-testid="footer-terms-link">Terms Of Service</Link>
      <Link to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link>
      <Link to="/disclaimer" data-testid="footer-disclaimer-link">Disclaimer</Link>
    </nav>
    <p data-testid="footer-copyright">© 2026 BurrHaus Counseling. All rights reserved.</p>
  </footer>
);
